import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ElixirMain } from "./elixir";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ElixirMain />
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.querySelector("#app"));
